// extracted by mini-css-extract-plugin
export var container = "_d5-1";
export var cornerButtonContainer = "_d5-6";
export var disabled = "_d5-2";
export var dragActive = "_d5-3";
export var fileContainer = "_d5-5";
export var hiddenInput = "_d5-4";
export var widthContainer = "_d5-0";